import { FINANCIAL_SUMMARY_PRESET_ID, FOLLOW_UP_EMAIL_PRESET_ID } from './TemplateTypeMapping'
import { TemplateTab, TemplateTabContent } from '../../../models/TemplateLibrary'

export const TEMPLATE_TABS: (TemplateTabContent | TemplateTab)[] = [
  {
    key: 'your-templates',
    label: 'Your templates',
    header: 'Your templates in one place',
    subHeader: "Templates you've created and customized",
    searchParams: {
      scopes: ['user'],
    },
    showTemplateType: true,
  },
  {
    key: 'meeting-types-group',
    label: 'Meeting types',
  },
  {
    key: 'meeting-prep',
    label: 'Meeting prep',
    header: 'Meeting prep templates',
    subHeader: 'Use these templates for meeting prep in meeting types',
    searchParams: {
      type: 'meeting-preparation-template',
    },
    showTemplateType: false,
  },
  {
    key: 'meeting-prep-email',
    label: 'Meeting prep email',
    header: 'Meeting prep email templates',
    subHeader: 'Use these templates for meeting prep emails in meeting types',
    searchParams: {
      type: 'meeting-preparation-email-template',
    },
    showTemplateType: false,
  },
  {
    key: 'meeting-summary',
    label: 'Meeting summary',
    header: 'Meeting summary templates',
    subHeader: 'Use these templates for meeting summaries in meeting types',
    searchParams: {
      type: 'meeting-summary-template',
    },
    showTemplateType: false,
  },
  {
    key: 'presets-group',
    label: 'Presets',
  },
  {
    key: 'financial-summary-preset',
    label: 'Financial summary',
    header: 'Financial summaries',
    subHeader: 'Use these templates for financial summaries in meeting presets',
    searchParams: {
      type: 'ai-feature-presets',
      typeId: FINANCIAL_SUMMARY_PRESET_ID,
      defaultTypeId: FINANCIAL_SUMMARY_PRESET_ID,
    },
    showTemplateType: false,
  },
  {
    key: 'follow-up-email-preset',
    label: 'Follow-up email',
    header: 'Follow-up emails',
    subHeader: 'Use these templates for follow-up emails in meeting presets',
    searchParams: {
      type: 'ai-feature-presets',
      typeId: FOLLOW_UP_EMAIL_PRESET_ID,
      defaultTypeId: FOLLOW_UP_EMAIL_PRESET_ID,
    },
    showTemplateType: false,
  },
  {
    key: 'email-types-group',
    label: 'Email types',
  },
  {
    key: 'reply-email',
    label: 'Reply email',
    header: 'Reply email templates',
    subHeader: 'Use these templates for reply emails in email types',
    searchParams: {
      type: 'email-response-template',
    },
    showTemplateType: false,
  },
  {
    key: 'new-email',
    label: 'New email',
    header: 'New email templates',
    subHeader: 'Use these templates for new emails in email types',
    searchParams: {
      type: 'new-email-template',
    },
    showTemplateType: false,
  },
  {
    key: 'document-types-group',
    label: 'Document types',
  },
  {
    key: 'document-summary',
    label: 'Document summary',
    header: 'Document summary templates',
    subHeader: 'Use these templates for document summaries in document types',
    searchParams: {
      type: 'document-summary-template',
    },
    showTemplateType: false,
  },
]

export const TEMPLATE_TYPES: TemplateTabContent[] = TEMPLATE_TABS.filter(
  (tab) => 'searchParams' in tab && tab.searchParams !== undefined,
) as TemplateTabContent[]
